import { allCountriesNewList } from "./countryLists.js";
const getAllCountries = ()=>allCountriesNewList;
const buildCountryDropdown_allCountriesByCode = getAllCountries().reduce((allCountriesByCode, country)=>{
    allCountriesByCode[country.code] = country;
    return allCountriesByCode;
}, {});
function buildCountryDropdown() {
    const allCountriesHashmap = {};
    const allCountriesList = [];
    getAllCountries().forEach((country)=>{
        if (allCountriesHashmap[country.phoneCode]) {
            if ('us' === country.code) allCountriesHashmap[country.phoneCode].names.unshift(country.name);
            else if ('pr' !== country.code) allCountriesHashmap[country.phoneCode].names.push(country.name);
        } else allCountriesHashmap[country.phoneCode] = {
            names: [
                country.name
            ],
            phoneCode: country.phoneCode
        };
    });
    for(const keyNumber in allCountriesHashmap)if (Object.prototype.hasOwnProperty.call(allCountriesHashmap, keyNumber)) {
        const number = {
            ...allCountriesHashmap[keyNumber]
        };
        number.names = `+${keyNumber} ${number.names.join(' and ')}`;
        allCountriesList.push(number);
    }
    return allCountriesList;
}
const uniqCountryCodes = buildCountryDropdown().map((country)=>({
        phoneCode: parseInt(country.phoneCode),
        label: country.names
    }));
export { buildCountryDropdown_allCountriesByCode as allCountriesByCode, buildCountryDropdown, getAllCountries, uniqCountryCodes };
